import { alpha } from '@material-ui/core/styles/colorManipulator';

const stylesTooltip = (theme) => ({
  tooltip: {
    width: '100%',
    backgroundColor: 'white',
    border: `1px solid ${theme.palette.primary.main}`,
  },
  arrow: {
    color: alpha(theme.palette.primary.main, 0.2),
  },
});

export default stylesTooltip;
